// extracted by mini-css-extract-plugin
module.exports = {"certificateContainer":"Certificate_certificateContainer__eLZzs","certificate":"Certificate_certificate__1KNqr"};